export default __webpack_public_path__ + "static/media/hero.2d4d0795.jpg";